import React from "react";

const CommitmentSection = () => {
	return (
		<section
			className=" md:py-20 py-10 px-5 relative min-h-125 w-full flex items-center overflow-hidden bg-gray-900"
			style={{
				backgroundImage:
					'url("/assets/images/transportation-illustration-ai-generated.jpg")',
				backgroundSize: "cover",
				backgroundPosition: "center",
			}}
		>
			{/* Dark Gradient Overlay for Readability */}
			<div className="absolute inset-0 md:bg-linear-to-r bg-linear-to-b from-black via-black/80 to-transparent z-10"></div>

			<div className="container mx-auto px-4 relative z-20">
				<div className="flex flex-col lg:flex-row items-center gap-12">
					{/* Text Content */}
					<div className="w-full lg:w-3/5 text-white space-y-6">
						<div className="inline-block px-3 py-1 bg-brand-600 rounded text-[10px] font-bold uppercase tracking-[0.3em] mb-2">
							Our Values
						</div>

						<h4 className="text-3xl md:text-4xl Ethnocentric uppercase leading-tight tracking-wider">
							Our Commitment
						</h4>

						<p className="text-gray-300 text-lg leading-relaxed max-w-2xl font-light">
							At Blue Dart, we don't just move shipments —{" "}
							<span className="text-white font-semibold">
								we move promises.{" "}
							</span>
							We're committed to delivering speed with care, precision with
							every mile, and trust in every box. With certified processes,
							real-time tracking, and a team that truly listens, we go the extra
							mile — so your business doesn't have to.
						</p>

						{/* Micro-stat or subtle detail */}
						<div className="flex items-center gap-6 pt-4 border-t border-white/10">
							<div>
								<p className="Ethnocentric text-brand-500 text-xl">100%</p>
								<p className="text-[10px] uppercase opacity-60">
									Certified Process
								</p>
							</div>
							<div className="w-px h-10 bg-white/10"></div>
							<div>
								<p className="Ethnocentric text-brand-500 text-xl">Live</p>
								<p className="text-[10px] uppercase opacity-60">
									Real-time Tracking
								</p>
							</div>
						</div>
					</div>

					{/* Image Content with Modern Frame */}
					<div className="w-full lg:w-2/5 relative">
						<div className="relative group">
							{/* Decorative border frame */}
							<div className="absolute -inset-4 border border-brand-500/30 rounded-2xl -z-10 translate-x-4 translate-y-4 gh:translate-x-2 gh:translate-y-2 transition-transform duration-500"></div>

							<div className="rounded-2xl overflow-hidden shadow-2xl border-4 border-white/10">
								<img
									src="/assets/images/transport-logistics-products.jpg"
									alt="Transport logistics"
									className="w-full h-auto object-cover transform transition-transform duration-700 gh:scale-105"
								/>
							</div>

							{/* Subtle glassmorphism badge on the image */}
							<div className="absolute bottom-4 left-4 right-4 bg-black/40 backdrop-blur-md p-3 rounded-xl border border-white/10 text-center">
								<p className="text-white text-[10px] uppercase tracking-widest font-bold">
									The World On Time
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default CommitmentSection;
